import { Component, OnInit, OnDestroy, HostListener, ChangeDetectionStrategy } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { interval, Subscription } from 'rxjs';
import { ContentHeaderKey } from 'src/app/constants/content-header';

import {
  BenefitCategory,
  BenefitCategorySummary,
} from 'src/app/models/benefit-category';
import { ResourceLink } from 'src/app/models/resource-link';
import { TableColumn, MatTableLoad } from 'src/app/models/table';

import { BenefitService } from 'src/app/services/benefit.service';
import { HelperService } from 'src/app/services/helper.service';

@Component({
  selector: 'mwp-member-available-benefits',
  templateUrl: './available-benefits.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class MemberAvailableBenefitsComponent implements OnInit, OnDestroy {
  // Issue: https://youtrack.myworkplace.net/issue/WEBSITES-1516/API-Bug-infinite-error-loop-benefit-categories-time-out
  // When the user is auto logged out on this page and refresh is done, this will kill the interval check subscribiton.
  @HostListener('window:beforeunload', ['$event'])
  beforeUnload(e: Event) {
    this.ngOnDestroy();
  }

  public apiUrl = ContentHeaderKey.AvailableBenefits;

  public benefitCategories: BenefitCategory[];
  public selectedCategoryId: number;
  public isLoading: boolean = true;

  private subscriptions: Subscription[] = [];

  public displayAvailableBenefits = false;
  public availableBenefits: MatTableDataSource<any>;
  public availableBenefitColumns: TableColumn[];

  public displayResourceLinks = false;
  public benefitCategoryName: string;
  public benefitCategoryDocuments: ResourceLink[];

  public displayFauxCategory = false;
  public categoryHTML: string;
  public categoryOptionHTML: string;

  constructor(
    private benefitService: BenefitService,
    private helperService: HelperService,
  ) { }

  ngOnInit(): void {
    this.getBenefitCategories();

    const intervalCheck = interval(3500).subscribe(() => {
      this.getBenefitCategories();
    });
    this.subscriptions.push(intervalCheck);
  }

  ngOnDestroy(): void {
    this.killSubscriptions();
  }

  public getBenefitCategories(): void {
    if (this.benefitCategories) return;

    this.benefitService
      .getBenefitCategoreis()
      .subscribe((response: BenefitCategory[]) => {
        if (response && !this.benefitCategories) {
          this.benefitCategories = response;
          this.killSubscriptions();
          this.onMenuSelection(response[0]);
          this.isLoading = false;
        }
      });
  }

  private killSubscriptions(): void {
    this.subscriptions.forEach((s) => {
      s.unsubscribe();
    });
  }

  public onMenuSelection(benefitCategory: BenefitCategory): void {
    if (this.benefitCategories.length == 0) {
      return;
    }
    let l_IsFauxCategory = false;
    this.selectedCategoryId = benefitCategory.id;

    this.displayFauxCategory = false;
    this.displayAvailableBenefits = false;
    this.displayResourceLinks = false;
    this.isLoading = false;
    if (benefitCategory) {
      if (benefitCategory.isFauxCategory) {
        this.categoryHTML = benefitCategory.categoryHTML;
        this.categoryOptionHTML = benefitCategory.categoryOptionHTML;
        l_IsFauxCategory = true;
      } else {
        // Benefit Summaries
        if (
          benefitCategory.benefitCategorySummary &&
          benefitCategory.benefitCategorySummary.length > 0
        ) {
          const l_MatTableLoad: MatTableLoad =
            this.helperService.convertTableRowsToColumns(
              benefitCategory.benefitCategorySummary,
              true,
            );
          this.availableBenefitColumns = l_MatTableLoad.tableColumns;
          this.availableBenefits =
            new MatTableDataSource<BenefitCategorySummary>();
          this.availableBenefits.data = l_MatTableLoad.data;
        }

        // Benefit Resources
        if (
          benefitCategory.benefitCategoryDocuments &&
          benefitCategory.benefitCategoryDocuments.length > 0
        ) {
          this.benefitCategoryName = benefitCategory.benefitCategoryName;
          this.benefitCategoryDocuments =
            benefitCategory.benefitCategoryDocuments;
        } else {
          this.benefitCategoryDocuments = null;
        }
      }
    } else {
      this.availableBenefits = null;
      this.benefitCategoryDocuments = null;
    }

    if (l_IsFauxCategory) {
      this.displayFauxCategory = true;
      this.displayAvailableBenefits = false;
      this.displayResourceLinks = false;
    } else {
      this.displayFauxCategory = false;
      this.displayAvailableBenefits = true;
      this.displayResourceLinks = !!this.benefitCategoryDocuments;
    }
  }
}
